import React from "react";
import { formatAudAmount } from "../../../utils/audCurrency";

const BookingSummary = ({
  tutor,
  selectedTime,
  formattedDate,
  duration,
  onContinue,
  isPaymentEnabled,
  continueLabel,
  paymentBadgeLabel,
  paymentBadgeTone = "warning",
  statusDescription,
  isPaymentDisabled = false,
  bookingStatusLabel,
}) => {
  const badgeClasses =
    paymentBadgeTone === "success"
      ? "border border-green-200 bg-green-50 text-green-700"
      : "border border-amber-200 bg-amber-50 text-amber-700";

  return (
    <div className="flex h-full w-full flex-col bg-white rounded-2xl border border-gray-200 shadow-md p-8">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="text-gray-900 font-semibold">Booking Summary</h3>
          {bookingStatusLabel ? (
            <p className="mt-1 text-xs font-medium uppercase tracking-[0.14em] text-gray-400">
              Booking status: {bookingStatusLabel}
            </p>
          ) : null}
        </div>
        {paymentBadgeLabel ? (
          <span
            className={`rounded-full px-3 py-1 text-xs font-semibold ${badgeClasses}`}
          >
            {paymentBadgeLabel}
          </span>
        ) : null}
      </div>

      <div className="space-y-4 text-sm">
        <div>
          <p className="text-gray-500">Tutor</p>
          <p className="font-medium text-gray-900">{tutor.name}</p>
        </div>

        <div>
          <p className="text-gray-500">Date</p>
          <p className="font-medium text-gray-900">{formattedDate}</p>
        </div>

        <div>
          <p className="text-gray-500">Time</p>
          <p className="font-medium text-gray-900">
            {selectedTime || "Not selected"}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Duration</p>
          <p className="font-medium text-gray-900">{duration || "60 minutes"}</p>
        </div>
      </div>

      <div className="mt-6 bg-gray-50 rounded-xl p-4 border border-gray-200">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Session Fee</span>
          <span className="font-medium text-gray-900">
            {formatAudAmount(tutor.price)}
          </span>
        </div>

        <div className="flex justify-between mt-2 text-sm">
          <span className="text-green-600 font-medium">Total Amount</span>
          <span className="text-green-600 font-medium">
            {formatAudAmount(tutor.price)}
          </span>
        </div>
      </div>

      {statusDescription ? (
        <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-600">
          {statusDescription}
        </div>
      ) : null}

      <button
        onClick={onContinue}
        className={`mt-auto w-full py-3 rounded-xl shadow-md font-medium transition
          ${
            isPaymentEnabled && !isPaymentDisabled
              ? "bg-[#0736D6] text-white hover:bg-[#062FC0]"
              : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }
        `}
        disabled={!isPaymentEnabled || isPaymentDisabled}
      >
        {continueLabel || "Continue to Payment"}
      </button>
    </div>
  );
};

export default BookingSummary;
